define('view/controller/booking/result/BookingPushNotificationView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    /**
     * Push notifications
     *
     * @class BookingPushNotificationView
     */
    return LayoutView.extend({

        template: '#booking_result_push_notification',

        ui: {
            subscribeBtn: '.btn-push-subscribe',
            pushSuccessBlock: '.push-success'
        },

        events: {
            'click @ui.subscribeBtn' : 'onSubscribe'
        },

        pushNotifyObj : null,
        pushNotifyReady : false,

        initialize: function () {
            this.initPushNotifyObj();
            LayoutView.prototype.initialize.apply(this);
        },

        onBeforeShow : function () {
            //console.log(this.ui.subscribeBtn);
        },

        onSubscribe : function () {
            var _this = this;
            if(this.pushNotifyReady){
                this.pushNotifyObj.initPush(function (isAllowed, token) {
                    if(isAllowed){
                        _this._subscribeToPush(token);
                    }
                });
            }
        },

        initPushNotifyObj : function () {
            var _this = this;
            this.pushNotifyObj = new BrowserPushNotification({}, function () {
                _this.pushNotifyReady = true;
            });
        },


        _subscribeToPush : function (token) {
            var _this = this;
            var pushNotifyModel = this.getOption('pushModel');

            pushNotifyModel.subscribeToPush(token, function (data) {
                _this.ui.subscribeBtn.hide();
                _this.ui.pushSuccessBlock.show();
            }.bind(this));
            
        }

    });

});
